/* Heasmans product page script. Loaded by every hx- section; runs once. */
(function () {
  if (window.HX_LOADED) return;
  window.HX_LOADED = true;

  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------- Vehicle ---------------- */
  function readVehicle(key) {
    try {
      var params = new URLSearchParams(location.search);
      var fromUrl = params.get('vehicle');
      if (fromUrl) localStorage.setItem(key, fromUrl);
      var raw = fromUrl || localStorage.getItem(key);
      if (!raw) return '';
      if (raw.charAt(0) === '{') {
        var obj = JSON.parse(raw);
        return obj.label || obj.name || [obj.year, obj.make, obj.model, obj.chassis].filter(Boolean).join(' ');
      }
      return raw;
    } catch (e) { return ''; }
  }

  function initVehicle() {
    var bar = document.querySelector('[data-hx-vbar]');
    var key = (bar && bar.dataset.storageKey) || 'heasmans_vehicle';
    var name = readVehicle(key);
    if (bar) {
      var set = !!name;
      bar.querySelectorAll('[data-hx-vehicle-name]').forEach(function (el) { el.textContent = name; });
      toggle(bar.querySelector('[data-hx-vbar-set]'), set);
      toggle(bar.querySelector('[data-hx-vbar-note]'), set);
      toggle(bar.querySelector('[data-hx-vbar-short]'), set);
      toggle(bar.querySelector('[data-hx-vbar-empty]'), !set);
    }
    if (name) {
      document.querySelectorAll('[data-hx-vehicle-input]').forEach(function (input) {
        if (!input.value) input.value = name;
      });
    }
  }

  function toggle(el, show) { if (el) el.hidden = !show; }

  /* ---------------- Product ---------------- */
  function initProduct(wrap) {
    if (!wrap || wrap.dataset.hxReady) return;
    wrap.dataset.hxReady = '1';

    var variants = [];
    try { variants = JSON.parse(wrap.querySelector('[data-hx-variants]').textContent); } catch (e) {}
    var form = document.getElementById(wrap.dataset.formId);
    var idInput = wrap.querySelector('[data-hx-variant-input]');
    var optionSets = Array.prototype.slice.call(wrap.querySelectorAll('[data-hx-option]'));
    var productTitle = '';
    try { productTitle = JSON.parse(wrap.querySelector('[data-hx-product-title]').textContent); } catch (e) {}

    function selected() {
      return optionSets.map(function (set) {
        var active = set.querySelector('.hx-pill.is-active');
        return active ? active.dataset.hxValue : null;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || opts[i] === o; });
      });
    }

    function setActive(set, value) {
      set.querySelectorAll('.hx-pill').forEach(function (p) {
        var on = p.dataset.hxValue === value;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var label = set.querySelector('[data-hx-option-value]');
      if (label) label.textContent = value;
    }

    function markAvailability(opts) {
      optionSets.forEach(function (set, i) {
        set.querySelectorAll('.hx-pill').forEach(function (p) {
          var test = opts.slice();
          test[i] = p.dataset.hxValue;
          var match = variants.find(function (v) {
            return v.options.every(function (o, j) { return test[j] === o; });
          });
          p.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update(variant, opts) {
      markAvailability(opts);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;

      function priceText(el) {
        return variant.zero && el.dataset.zeroLabel ? el.dataset.zeroLabel : variant.price;
      }
      wrap.querySelectorAll('[data-hx-price]').forEach(function (el) { el.textContent = priceText(el); });
      if (wrap.querySelector('[data-hx-price]')) {
        wrap.querySelectorAll('[data-hx-sticky-price]').forEach(function (el) { el.textContent = priceText(el); });
      }
      wrap.querySelectorAll('[data-hx-compare]').forEach(function (el) {
        el.textContent = variant.compare || '';
        el.hidden = !variant.compare;
      });
      wrap.querySelectorAll('[data-hx-sku]').forEach(function (el) { el.textContent = variant.sku || ''; });

      wrap.querySelectorAll('[data-hx-stock]').forEach(function (el) {
        el.textContent = variant.available ? el.dataset.in : el.dataset.out;
        el.classList.toggle('is-out', !variant.available);
      });

      wrap.querySelectorAll('[data-hx-add]').forEach(function (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? btn.dataset.label : btn.dataset.soldOut;
      });
      wrap.querySelectorAll('[data-hx-sticky-add]').forEach(function (btn) { btn.disabled = !variant.available; });

      var chosen = optionSets.map(function (set, i) {
        var name = set.querySelector('.hx-option__name');
        return (name ? name.textContent.trim() + ': ' : '') + opts[i];
      }).join(', ');
      document.querySelectorAll('[data-hx-chosen-options]').forEach(function (el) { el.value = chosen; });

      if (variant.media) goToMedia(variant.media);

      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}
    }

    optionSets.forEach(function (set, i) {
      set.addEventListener('click', function (e) {
        var pill = e.target.closest('.hx-pill');
        if (!pill) return;
        setActive(set, pill.dataset.hxValue);
        var opts = selected();
        var variant = findVariant(opts);
        if (!variant) {
          // That combination doesn't exist: keep this choice and pick the closest variant that has it.
          variant = variants.find(function (v) { return v.options[i] === opts[i] && v.available; }) ||
                    variants.find(function (v) { return v.options[i] === opts[i]; });
          if (variant) {
            optionSets.forEach(function (s, j) { setActive(s, variant.options[j]); });
            opts = variant.options.slice();
          }
        }
        update(variant, opts);
      });
    });
    if (optionSets.length) markAvailability(selected());

    /* Quantity */
    wrap.querySelectorAll('[data-hx-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = wrap.querySelector('[data-hx-qty-input]');
        if (!input) return;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.hxQty, 10));
        input.value = next;
      });
    });

    /* Add to cart, with the fitting add-on as a second line */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qtyInput = wrap.querySelector('[data-hx-qty-input]');
        var items = [{ id: Number(idInput.value), quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1 }];
        var fit = wrap.querySelector('[data-hx-fitting]');
        if (fit && fit.checked && fit.value && fit.value !== 'on') {
          items.push({ id: Number(fit.value), quantity: 1, properties: { 'Fitting for': productTitle } });
        }
        var buttons = wrap.querySelectorAll('[data-hx-add], [data-hx-sticky-add]');
        var error = wrap.querySelector('[data-hx-error]');
        buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        if (error) error.hidden = true;

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            if (!r.ok) throw new Error(r.data.description || r.data.message || 'This item could not be added to your cart.');
            document.dispatchEvent(new CustomEvent('hx:cart:added', { detail: r.data, bubbles: true }));
            if (wrap.dataset.afterAdd === 'cart') {
              location.href = root + 'cart';
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            buttons.forEach(function (b) {
              if (b.dataset.added) {
                b.textContent = b.dataset.added;
                setTimeout(function () { b.textContent = b.dataset.label; }, 2000);
              }
            });
          })
          .catch(function (err) {
            if (error) { error.textContent = err.message; error.hidden = false; }
          })
          .finally(function () {
            buttons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
          });
      });
    }

    /* Gallery */
    var track = wrap.querySelector('[data-hx-track]');
    var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-hx-thumb]'));
    var count = wrap.querySelector('[data-hx-count]');

    function goTo(index) {
      if (!track) return;
      track.scrollTo({ left: track.clientWidth * index, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function goToMedia(mediaId) {
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var index = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (index > -1) goTo(index);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.hxThumb, 10)); });
    });
    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
          if (count) count.textContent = index + 1;
          var active = thumbs[index];
          if (active && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
            active.parentElement.scrollTo({ left: active.offsetLeft - 16, behavior: 'smooth' });
          }
          ticking = false;
        });
      }, { passive: true });
    }

    /* Sticky bar */
    var sticky = wrap.querySelector('[data-hx-sticky]');
    var anchor = wrap.querySelector('[data-hx-buy-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      }).observe(anchor);
    }
  }

  /* ---------------- Accordions: open on desktop, collapsible on mobile ---------------- */
  function applyAccordions() {
    document.querySelectorAll('[data-hx-acc]').forEach(function (d) {
      if (DESKTOP.matches) {
        d.open = true;
      } else if (!d.dataset.hxMobileSet) {
        d.dataset.hxMobileSet = '1';
        if (d.hasAttribute('data-mobile-closed')) d.open = false;
      }
    });
  }
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('[data-hx-acc] > summary');
    if (!summary || !DESKTOP.matches) return;
    if (e.target.closest('a, button')) return;
    e.preventDefault();
  });

  /* Opening a link to an anchor inside a closed accordion (mobile) opens it */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (target && target.matches('details')) target.open = true;
  });

  /* ---------------- In-page nav: highlight the section in view ---------------- */
  function initNav() {
    var nav = document.querySelector('[data-hx-nav]');
    if (!nav || nav.dataset.hxReady || !('IntersectionObserver' in window)) return;
    nav.dataset.hxReady = '1';
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var map = new Map();
    links.forEach(function (l) {
      var t = document.getElementById(l.getAttribute('href').slice(1));
      if (t) map.set(t, l);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (l) { l.classList.remove('is-active'); });
        var l = map.get(entry.target);
        if (l) l.classList.add('is-active');
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    map.forEach(function (_, t) { io.observe(t); });
  }


  /* ---------------- Product tabs ---------------- */
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function initTabs(wrap) {
    if (!wrap || wrap.dataset.hxReady) return;
    wrap.dataset.hxReady = '1';
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-hx-tab]'));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-hx-panel]'));
    var accBtns = Array.prototype.slice.call(wrap.querySelectorAll('[data-hx-acc-btn]'));
    var accordion = function () { return wrap.dataset.mobileStyle === 'accordion' && MOBILE.matches; };

    function activate(id, focus) {
      tabs.forEach(function (t) {
        var on = t.dataset.hxTab === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
        if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      panels.forEach(function (p) { p.hidden = p.id !== id; });
      accBtns.forEach(function (b) { b.setAttribute('aria-expanded', b.dataset.hxAccBtn === id ? 'true' : 'false'); });
    }
    wrap.hxActivate = activate;

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t.dataset.hxTab); });
      t.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activate(next.dataset.hxTab, true); }
      });
    });

    /* Accordion headings on mobile: each opens and closes on its own */
    accBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var panel = document.getElementById(b.dataset.hxAccBtn);
        if (!panel) return;
        var open = panel.hidden;
        panel.hidden = !open;
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Switching between mobile accordions and tabs: show one tab again */
    function resync() {
      if (accordion()) return;
      var current = tabs.find(function (t) { return t.getAttribute('aria-selected') === 'true'; }) || tabs[0];
      if (current) activate(current.dataset.hxTab);
    }
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', resync);

    /* Open the tab named in the page address, e.g. /products/x#specs */
    if (location.hash) {
      var fromHash = location.hash.slice(1);
      if (panels.some(function (p) { return p.id === fromHash; })) activate(fromHash);
    }
  }

  /* Links to a tab (e.g. href="#specs") open it and scroll to the tabs */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target || !target.matches('[data-hx-panel]')) return;
    var wrap = target.closest('[data-hx-tabs]');
    if (!wrap || !wrap.hxActivate) return;
    e.preventDefault();
    wrap.hxActivate(target.id);
    wrap.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  /* Theme editor: selecting a tab block shows that tab */
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target;
    if (!panel || !panel.matches || !panel.matches('[data-hx-panel]')) return;
    var wrap = panel.closest('[data-hx-tabs]');
    if (wrap && wrap.hxActivate) wrap.hxActivate(panel.id);
  });

  /* ---------------- Recommendations fallback ---------------- */
  function initRecs() {
    document.querySelectorAll('[data-hx-recs]').forEach(function (el) {
      if (el.dataset.hxReady || !el.dataset.url) return;
      el.dataset.hxReady = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-hx-recs]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }

  function initAll() {
    initVehicle();
    document.querySelectorAll('[data-hx-product]').forEach(initProduct);
    document.querySelectorAll('[data-hx-tabs]').forEach(initTabs);
    applyAccordions();
    initNav();
    initRecs();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', applyAccordions);
  document.addEventListener('shopify:section:load', initAll);
})();
